// Configuration for Automated Onboarding

// ...export automated onbarding pages as constants to be used for navigation
export const AUTOONBOARD_FISCAL_CALENDAR_PAGE = "FISCAL_CALENDAR_CREATION";
export const AUTOONBOARD_ACCOUNT_GROUP_MAPPING_PAGE = "ACCOUNT_GROUP_MAPPING";
export const AUTOONBOARD_REVIEW_DATA_PAGE = "REVIEW_DATA";
export const AUTOONBOARD_CREATE_BUDGET_PAGE = "CREATE_BUDGET";

export const AUTOONBOARD_NAVIGATION_TYPE_NEXT = "NEXT";
export const AUTOONBOARD_NAVIGATION_TYPE_BACK = "BACK";
export const AUTOONBOARD_SAVE_TYPE_SAVE_ONLY = "SAVE_ONLY";
export const AUTOONBOARD_SAVE_TYPE_SAVE_COMPLETE = "SAVE_COMPLETE";

export const ZERO_GROWTH_RATE = "ZERO_GROWTH_RATE";
